export enum TipoHoldeo{
    TodaFacturacion = 0,
    CuentaCliente = 1,
    Aerovale = 2
}